export default __webpack_public_path__ + "static/media/TF_15.0aa70d0d.png";